"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultMenuItemNames = void 0;
var defaultMenuItemNames = exports.defaultMenuItemNames = ['today', 'yesterday', 'this_week', 'last_week', 'this_month', 'last_month', 'custom'];